import React from "react";
import { useI18n } from "../../lib/i18n.jsx";
import RootsDraw from "./animations/RootsDraw.jsx";

export default function Historia() {
  const { t } = useI18n();
  const h = t.historia;

  return (
    <section
      id="historia"
      className="relative py-24 lg:py-32 bg-[#0e2618] text-[#f7f7f4] overflow-hidden"
      data-testid="historia-section"
    >
      {/* Decorative glows */}
      <div className="absolute inset-0 pointer-events-none opacity-30">
        <div className="absolute -top-32 -left-32 w-[600px] h-[600px] rounded-full bg-[#9ead9b]/20 blur-3xl" />
        <div className="absolute -bottom-32 -right-32 w-[600px] h-[600px] rounded-full bg-[#b45f3e]/20 blur-3xl" />
      </div>

      {/* Subtle grid */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(247,247,244,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(247,247,244,0.6) 1px, transparent 1px)",
          backgroundSize: "80px 80px",
        }}
      />

      {/* Roots drawing on scroll — anchored to the bottom, draws once */}
      <div className="absolute inset-x-0 bottom-0 h-[240px] pointer-events-none opacity-80">
        <RootsDraw className="w-full h-full" />
      </div>

      <div className="relative max-w-6xl mx-auto px-6 lg:px-10">
        {/* Intro */}
        <div className="text-center max-w-3xl mx-auto">
          <div className="eu-data-label text-[#9ead9b] mb-6 inline-flex items-center justify-center">
            <i className="fa-solid fa-book-open mr-2"></i>
            {h.eyebrow}
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#f7f7f4] leading-[1.05] tracking-tight">
            {h.title}
          </h2>
          <div className="mt-10 space-y-5 text-base lg:text-lg text-[#f7f7f4]/85 leading-relaxed">
            <p>{h.intro1}</p>
            <p>{h.intro4}</p>
          </div>

          {/* Tagline + lema */}
          <div className="mt-14 border-y border-[#f7f7f4]/15 py-10">
            <p className="font-display text-2xl lg:text-3xl italic text-[#9ead9b]">
              "{h.tagline}"
            </p>
            <p className="mt-4 text-sm font-mono-eu tracking-[0.25em] uppercase text-[#b45f3e]">
              — {h.lema}
            </p>
          </div>
        </div>

        {/* 3 Pillars */}
        <div className="mt-20">
          <div className="eu-data-label text-[#9ead9b] mb-10 text-center">
            {h.pillarsLabel}
          </div>
          <div className="grid md:grid-cols-3 gap-5">
            {h.pillars.map((p, i) => (
              <article
                key={i}
                className="relative bg-[#f7f7f4]/[0.04] hover:bg-[#f7f7f4]/[0.07] border border-[#f7f7f4]/10 rounded-2xl p-7 lg:p-8 transition group"
                data-testid={`historia-pillar-${i}`}
              >
                <div className="absolute top-6 right-6 font-mono-eu text-xs text-[#f7f7f4]/30 tracking-wider">
                  0{i + 1}
                </div>
                <div className="h-12 w-12 rounded-full bg-[#b45f3e]/20 border border-[#b45f3e]/30 flex items-center justify-center mb-6 group-hover:bg-[#b45f3e]/30 transition">
                  <i className={`${p.icon} text-[#b45f3e] text-lg`}></i>
                </div>
                <h3 className="font-display text-2xl text-[#f7f7f4] leading-tight">
                  {p.title}
                </h3>
                <p className="mt-4 text-sm lg:text-[15px] leading-relaxed text-[#f7f7f4]/75">
                  {p.text}
                </p>
              </article>
            ))}
          </div>
        </div>

        {/* Expansión */}
        <div className="mt-20 max-w-3xl mx-auto bg-[#f7f7f4]/[0.03] border-l-2 border-[#b45f3e] pl-6 pr-5 py-7 rounded-r-2xl">
          <div className="flex items-center gap-2 text-[#9ead9b] eu-data-label mb-3">
            <i className="fa-solid fa-globe text-[#b45f3e]"></i>
            {h.expansionLabel}
          </div>
          <p className="text-sm lg:text-[15px] leading-relaxed text-[#f7f7f4]/85">
            {h.expansion}
          </p>
        </div>
      </div>
    </section>
  );
}
